export const ACTIVE_ACCOUNT_KEY = "mail.activeAccount";

// Storage may be unavailable (private mode); the selection then just isn't remembered.
export const readStoredAccount = () => {
  try {
    return localStorage.getItem(ACTIVE_ACCOUNT_KEY);
  } catch {
    return null;
  }
};

export const storeAccount = id => {
  try {
    localStorage.setItem(ACTIVE_ACCOUNT_KEY, id);
  } catch {
    // ignored, see above
  }
};
